import React from 'react';
import {
  Box,
  Typography,
  Divider,
  Chip,
  useMediaQuery,
} from '@mui/material';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad'
import { makeStyles } from '@mui/styles';
import {SectionTitle} from './SectionTitle';
import { StarBorder } from '@mui/icons-material';
import useServiceCard from '../../shared/logic/useServiceCard';
import { Rating } from '@mui/material';
import { theme } from '../Template';
import ShareFloatButtons from './ShareFloatButtons';
import NoImage from 'src/assets/images/no-pictures.png'
import { useCompanyData } from '../../shared/contexts/DataContext';
import OnlineTag from './OnlineTag';
import { extractContent } from '../../shared/logic/Utils';
import { textVariant, textClasses } from '../../shared/config';

const useStyles = makeStyles(() => ({
  iconFilled:{
    color: '#0BDED6 !important',
  },

  iconHover:{
    color: '#0BDED6',
  },

  icon:{
    display:'unset !important'
  },

  card:props => ({
    boxShadow: props.shadow ? props?.shadow : '0 0 10px rgb(183, 175, 175)',
    "-webkit-box-shadow": props.shadow ? props?.shadow : '0 0 10px rgb(183, 175, 175)',
    "-moz-box-shadow": props.shadow ? props?.shadow : '0 0 10px rgb(183, 175, 175)',
    width:'100%',
    minWidth:'320px',
    backgroundColor:'#fff',

    '@media (min-width: 900px)': {
        maxWidth:'320px'
    },

    '@media (min-width: 992px)': {
      maxWidth:'400px'
    },
  })
}));

const ServiceCard = ({ service,displayDescription,productType, companyId, contentData }) => {
  const matches = useMediaQuery(theme.breakpoints.down('lg'));
  const serviceId= service && service.id;
  const { handleClick, rating, reviews } = useServiceCard({service,productType,companyId});
  const maxStringLength = matches ? 80 : 130;
  const { data } = useCompanyData();
  const { t, fontFamily, isRTL } = data || {};
  const classes = useStyles({shadow:contentData?.shadow,defaultShadow:'none'});

  const path = window.location.origin;
  const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${path}/${productType === 'categories' ? 'categories' : 'activity'}/${productType === 'categories' ? `${companyId}/${serviceId}` : serviceId}`;
  const twitterLink = `https://twitter.com/intent/tweet?url=${path}/${productType === 'categories' ? 'categories' : 'activity'}/${productType === 'categories' ? `${companyId}/${serviceId}` : serviceId}`;
  const whatsappLink = `https://wa.me/?text=${path}/${productType === 'categories' ? 'categories' : 'activity'}/${productType === 'categories' ? `${companyId}/${serviceId}` : serviceId}`;

  const shortDescription = productType === 'categories' ? extractContent(service?.description) : extractContent(service?.shortDescription);
  const cardRadius = contentData?.cardRadius ? `${contentData?.cardRadius}px` : '15px'; 
  const cardBorder = contentData?.border || 'none'; 

  const titleFontSize = contentData?.cardTitleFontSize ? contentData?.cardTitleFontSize : '24';
  const descriptionFontSize = contentData?.cardTextFontSize ? contentData?.cardTextFontSize : '16';

  const titleFontColor = contentData?.cardTitleColor ? contentData?.cardTitleColor : '';
  const descFontColor = contentData?.cardTextColor ? contentData?.cardTextColor : '';

  return (
    <Box style={{
      position:'relative',
      overflow:'hidden',
      cursor:'pointer',
      marginBottom:'30px',
      marginRight:matches ? '0px' : '12px',
      ...((contentData?.cardBackgroundStyle === 'image' && contentData?.cardBackgroundImage) ? 
        {
            backgroundSize: "cover",
            backgroundImage: `url(${contentData?.cardBackgroundImage})`,
            backgroundRepeat: "no-repeat",
        } 
      : 
      (contentData?.cardBackgroundStyle === 'gradient' && contentData?.cardBackgroundColor) ? 
        {
            backgroundImage: contentData?.cardBackgroundColor ? contentData?.cardBackgroundColor : '#ffffff',
        } 
      :
      (contentData?.cardBackgroundStyle === 'solidColor' && contentData?.cardBackgroundColor) ? 
        {
            backgroundColor: contentData?.cardBackgroundColor || '#ffffff',
        } 
      : 
        {backgroundColor: 'transparent'}
      ),
    }}
    className={classes.card}
    border={cardBorder}
    borderRadius={cardRadius}
    >
    <Box
      onClick={handleClick}
    >
      <Box width={'100%'} style={{position:'relative'}}>
        <OnlineTag
          online={service.online}
          color={service.online? '#18c699' : '#aeaeae'}
          bgColor='#154369'
        />
        <Box height="206px" bgcolor="#fff" style={{width:'100%'}}>
          <ImgLazyLoad>
            <img
              style={{ width: '100%', height: '100%', objectFit: productType === 'categories' && !service.photo ? 'contain' : 'fill' }}
              src={productType === 'categories' ? service.photo ? service.photo : NoImage : service?.cover}
              alt={service?.name || 'service'}
            />
          </ImgLazyLoad>
        </Box>
        <Box height="200px" px={2} py={2}>
          <Box pb={1}>
            <Chip
              label={service?.serviceCategory || service?.name}
              style={{
                borderRadius: '6px',
                fontWeight: 600,
                fontSize: '0.7rem',
                backgroundColor: '#E1F8F2',
                color: '#17C799',
                textTransform:'capitalize'
              }}
            />
          </Box>
          <Box pr={2}>
            <SectionTitle pFontSize={titleFontSize} color={titleFontColor} customCls="twoLineTxt">
              {service?.name}
            </SectionTitle>
          </Box>

          { displayDescription ?
          <Box pr={2}>
            <Typography variant={textVariant?.[descriptionFontSize]} style={{fontFamily,...(descFontColor ? {color:descFontColor} : {})}} className={`twoLineTxt ${textClasses?.[descriptionFontSize]}`}>
              {shortDescription?.substring(0, maxStringLength)}
              {shortDescription.length > maxStringLength && '...'}
            </Typography>
          </Box>
          : null }
          {productType === 'categories' ?
            null
            :
            <Box position='absolute' style={{bottom:'9px',width:'100%',left:'0px'}}>
            <Divider />
            <div style={{display:'flex',flexDirection:'row',alignItems:'center',paddingTop:'5px',paddingBottom:'5px',...(isRTL === 'ar' ? {paddingRight:'16px'} : {paddingLeft:'16px'})}}>
              <Rating
                classes={{iconHover:classes.iconHover,iconFilled:classes.iconFilled,icon:classes.icon}}
                name="half-rating-read"
                value={Number(rating)}
                precision={0.1}
                readOnly
                emptyIcon={<StarBorder fontSize="inherit" />}
              />
                <span style={{margin: '0 0.5em',color: '#15476D',fontFamily}}>{t('service.review',{count:reviews})}</span>
            </div>
            </Box>
          }
        </Box>
      </Box>
    </Box>
      <ShareFloatButtons {...{facebookLink,twitterLink,whatsappLink,productType}}/>
    </Box>
  );
};

export default ServiceCard;
